/**
 * Система истории - простой массив сообщений
 */

/**
 * Создает новый элемент истории
 * @param {string} type - Тип сообщения: 'system' или 'user'
 * @param {string} text - Текст сообщения
 * @param {string} [value] - Дополнительное значение (для user сообщений)
 * @param {number} [phraseIndex] - Индекс фразы
 * @returns {Object} - Элемент истории
 */
export const createHistoryItem = (type, text, value = null, phraseIndex = null) => {
  return {
    type, // 'system' | 'user'
    text,
    value, // может быть null для system сообщений
    phraseIndex, // индекс фразы для фильтрации
    timestamp: Date.now()
  };
};

/**
 * Добавляет системное сообщение в историю
 * @param {Array} history - Массив истории
 * @param {string} text - Текст системного сообщения
 * @param {number} [phraseIndex] - Индекс фразы
 * @returns {Array} - Новый массив истории
 */
export const addSystemMessage = (history, text, phraseIndex = null) => {
  return [...history, createHistoryItem('system', text, null, phraseIndex)];
};

/**
 * Добавляет пользовательское сообщение в историю
 * @param {Array} history - Массив истории
 * @param {string} text - Текст вопроса/контекста
 * @param {string} value - Значение, введенное пользователем
 * @param {number} [phraseIndex] - Индекс фразы
 * @returns {Array} - Новый массив истории
 */
export const addUserMessage = (history, text, value, phraseIndex = null) => {
  return [...history, createHistoryItem('user', text, value, phraseIndex)];
};

/**
 * Добавляет оба сообщения (системное и пользовательское) для блока с вводом
 * @param {Array} history - Массив истории
 * @param {string} systemText - Текст системного сообщения (вопрос)
 * @param {string} userValue - Значение, введенное пользователем
 * @param {number} [phraseIndex] - Индекс фразы
 * @returns {Array} - Новый массив истории
 */
export const addInputHistory = (history, systemText, userValue, phraseIndex = null) => {
  return [
    ...history,
    createHistoryItem('system', systemText, null, phraseIndex),
    createHistoryItem('user', systemText, userValue, phraseIndex) // text здесь - это контекст вопроса, value - ответ
  ];
};

/**
 * Очищает историю
 * @returns {Array} - Пустой массив
 */
export const clearHistory = () => {
  return [];
};

